import useHttpPost from "./useHttpPost";

function usePostDepartment(target) {
  return useHttpPost("createdepartment", "post", {}, target);
}

export default usePostDepartment;
